import { Globe, FileText, Palette, Settings } from 'lucide-react';

export function Services() {
  const services = [
    {
      title: "SITE WEB COMPLET",
      description: "Design personnalisé, maquettage professionnel, et développement sur mesure pour votre présence en ligne.",
      icon: Globe,
      bgColor: "bg-orange-600",
      size: "large"
    },
    {
      title: "SITE VITRINE",
      description: "Présentation efficace et percutante en une seule page pour convertir vos visiteurs.",
      icon: FileText,
      bgColor: "bg-yellow-400",
      size: "medium"
    },
    {
      title: "IDENTITÉ VISUELLE",
      description: "Création de logos, cartes de visite et flyers qui reflètent votre image de marque.",
      icon: Palette,
      bgColor: "bg-violet-600",
      textColor: "text-white",
      size: "medium"
    },
    {
      title: "MAINTENANCE & SEO",
      description: "Sécurisation continue et optimisation pour améliorer votre visibilité en ligne.",
      icon: Settings,
      bgColor: "bg-cyan-400",
      size: "small"
    }
  ];

  return (
    <section id="services" className="bg-[#F0F8FF] py-20 px-6 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-32 h-32 bg-yellow-400 rounded-full opacity-20" />
      <div className="absolute bottom-20 left-10 w-24 h-24 bg-orange-600 rounded-full opacity-20" />
      
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black mb-4 leading-tight">
            MES SERVICES
          </h2>
          <p className="text-xl font-bold text-gray-700 max-w-2xl mx-auto">
            Une approche personnalisée pour transformer votre vision en réalité digitale
          </p>
        </div>

        {/* Grid Layout - 3 colonnes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className={`group relative bg-white border-4 border-black overflow-hidden transition-all duration-300 hover:shadow-[16px_16px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-2`}
              >
                {/* Top color bar */}
                <div className={`h-2 ${service.bgColor}`} />
                
                {/* Content */}
                <div className="p-8 relative">
                  {/* Icon container with animation */}
                  <div className={`${service.bgColor} ${service.textColor || 'text-black'} w-20 h-20 rounded-lg border-4 border-black flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-transform duration-300 shadow-[4px_4px_0px_0px_rgba(0,0,0,0.5)]`}>
                    <Icon className="w-10 h-10" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-2xl font-black mb-3 leading-tight h-16 flex items-center">
                    {service.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-base font-bold text-gray-700 mb-6 leading-relaxed h-20 flex items-start">
                    {service.description}
                  </p>
                  
                  {/* Bottom accent line */}
                  <div className={`h-1 ${service.bgColor} w-0 group-hover:w-full transition-all duration-300 mb-6`} />
                  
                  {/* Button */}
                  <a
                    href="#contact"
                    className={`inline-block ${service.bgColor} ${service.textColor || 'text-black'} px-6 py-3 font-black border-4 border-black shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1 hover:translate-y-1 transition-all`}
                  >
                    DEMANDER UN DEVIS →
                  </a>
                </div>
                
                {/* Hover background effect */}
                <div className={`absolute inset-0 ${service.bgColor} opacity-5 group-hover:opacity-10 transition-opacity duration-300 -z-10`} />
              </div>
            );
          })}
        </div>

        {/* Stats section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-20 pt-16 border-t-4 border-black">
          <div className="text-center">
            <div className="text-5xl font-black text-orange-600 mb-2">3 ANS</div>
            <p className="text-xl font-bold">D'EXPERTISE</p>
          </div>
          <div className="text-center">
            <div className="text-5xl font-black text-violet-600 mb-2">100%</div>
            <p className="text-xl font-bold">SATISFACTION</p>
          </div>
          <div className="text-center">
            <div className="text-5xl font-black text-cyan-400 mb-2">24/7</div>
            <p className="text-xl font-bold">SUPPORT</p>
          </div>
        </div>
      </div>
    </section>
  );
}
